var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidebar", class: { "is-collapsed": _vm.isCollapse } },
    [
      _c("logo", { attrs: { collapse: _vm.isCollapse } }),
      _c(
        "nav",
        {
          staticClass: "sidebar__nav",
          attrs: { "aria-label": _vm.$t("menu") },
        },
        [
          _c(
            "p",
            {
              staticClass: "sidebar__group-label",
              attrs: { "aria-hidden": "true" },
            },
            [_vm._v(_vm._s(_vm.$t("menu")))]
          ),
          _c(
            "ul",
            { staticClass: "sidebar-menu__list" },
            [
              _vm.userTermsOfUse
                ? _c(
                    "li",
                    [
                      _c("menu-link", {
                        attrs: {
                          to: "/home",
                          label: _vm.$t("home"),
                          icon: _vm.homeIcon,
                          active: _vm.activeMenu === _vm.homePath,
                          collapsed: _vm.isCollapse,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.permission_routes, function (route) {
                return _c("sidebar-item", {
                  key: route.path,
                  attrs: {
                    item: route,
                    "base-path": route.path,
                    "client-configuration": _vm.clientConfiguration,
                    "active-menu": _vm.activeMenu,
                    collapsed: _vm.isCollapse,
                  },
                  on: { clicked: _vm.itemClicked },
                })
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "sidebar__footer" },
        [_c("sidebar-user-menu", { attrs: { collapsed: _vm.isCollapse } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }